import * as actions from '../../redux/actions';
import HeroSection from '../../common/HeroSection/HeroSection';
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import CommonService from '../../../../services/commonService';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeTenTitle from '../components/ThemeTenTitle';

const getAmenitiesItems = operator => [
  {
    text: 'Entretención',
    image: getIcons('FleetTv', operator),
  },
  {
    text: 'Baños',
    image: getIcons('FleetToilet', operator),
  },
  {
    text: 'Climatización',
    image: getIcons('FleetAc', operator),
  },
  {
    text: 'Snacks',
    image: getIcons('FleetSnacks', operator),
  },
  {
    text: 'Semi cama',
    image: getIcons('FleetBed', operator),
  },
];

const firstFloor = [
  ' Sensor fatiga y somnolencia',
  'Sensor cambio de carril',
  'Sensor exceso de velocidad',
];
const secondFloor = [' Velocímetro visible', 'Monitoreo por GPS', 'Cámaras de seguridad'];

const interStateFleetOne = [
  ' Motor electrónico Volvo D11A con 450 CV.',
  'Computadora abordo con diagnóstico de fallas.',
  'Suspensión neumática con control electrónico.',
  'Sistema Volvo de frenos a disco EBS5: EBS (Electronic Braking System) con ABS y control de tracción.',
  'VEB – Freno Motor Volvo con 390 CV.',
  'ESP - Sistema de Control de Estabilidad.',
  ' Tercer eje direccional.',
  'Caja de cambios inteligente Volvo I-Shift.',
];

const interStateFleetTwo = [
  'Motor con 410 HP, Ciclo diesel, 4 tiempos, 6 cilindros en línea, tapas de cilindros individual y 4 válvulas por cilindro.',
  'Computadora de abordo con diagnóstico de fallas.',
  'Suspensión neumática con capacidad máxima de eje de 7.500 Kg, barra estabilizadora. Suspensión trasera: Neumática con capacidad máxima en el eje de ( 17.500 Kg).',
  'Sistema Frenos Modelo: R660 de simple reducción. Reducción: 2.92 (opcionales disponibles). Arrastre máximo: 40.000 Kg.',
  'ESP - Sistema de Control de Estabilidad.',
  ' Caja de cambios GR875. Descripción: Tipo sincronizada de 8 marchas. Doble gama. 1 marcha atrás. Sistema de cambios automatizado Scania Opticruise.',
];

const ThemeTenAboutUs = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const initalState = {
    selectedTab: 1,
  };

  const [state, setState] = useState(initalState);

  const tabs = ['Volvo B450 R 6X2 Euro5', 'Scania K410 6X2 Euro3'];

  const onTabChange = tab => {
    setState({ ...state, selectedTab: tab });
  };

  const interStateFleetDetails = state.selectedTab == 1 ? interStateFleetOne : interStateFleetTwo;

  const styles = {
    singleTab: {
      marginTop: 40,
      background: operator && operator.theme_color2,
      padding: 15,
      justifyContent: 'center',
      color: '#fff',
      borderTopRightRadius: 50,
      borderBottomRightRadius: 50,
    },
    interCityContainer: {
      background: '#F3F7FF',
      // height: 300,
      marginTop: -20,
      borderRadius: 10,
      paddingTop: 50,
      paddingLeft: 100,
      paddingRight: 100,
      paddingBottom: 30,
    },
  };

  return (
    <div>
      <KuposHelmet />
      <HeroSection
        heroImage={getIcons('AboutBanner', operator)}
        height={'41vh'}
        title={'La empresa'}
        description={'Home / La empresa'}
        marginTop="-50px"
      />
      <div className="new-container-compact">
        <ThemeTenTitle title={'TRANSPORTE Y LOGÍSTICA A TU MEDIDA'} />
        <div className="font10 montserrat y-kupos-value" style={{ marginTop: 50 }}>
          Traveltur desde 2007 viene cosechando reconocimiento en el mercado por su seriedad y
          compromiso con la seguridad de nuestros clientes y colaboradores. Somos fuerza en
          movimiento, contamos con una moderna flota y un equipo de trabajadores calificados, lo que
          nos permite entregar un servicio de calidad y hecho a la medida. Y en cuanto a visión, nos
          proyectamos al futuro basándonos en la preocupación por cada detalle del servicio,
          desarrollo de nuestro equipo humano, constante preocupación por la mejora de la seguridad,
          procesos y apoyo a las comunidades.
        </div>

        <div style={{ marginTop: 100 }}>
          <ThemeTenTitle title={'TU SEGURIDAD, NUESTRO BIEN MÁS PRECIADO'} />
          <div className="font10 montserrat y-kupos-value" style={{ marginTop: 50 }}>
            En Traveltur tomamos en serio lo que es sagrado: tu integridad y bienestar con nosotros,
            y para elo constantemente revisamos y actualizamos buses y tecnología en gral. Y velamos
            in situ a traves de una moderna central de monitoreo para cumplir y así tambien las
            normas de seguridad. Y nuestros colaboradores reciben la capacitación frecuente en las
            áreas de gestión de rutas, prevención de riesgos, administración y atención al cliente,
            entre otras.
          </div>
        </div>
      </div>

      <div
        // className="new-container"
        style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: 40 }}
      >
        <div style={{ marginTop: '10px' }}>
          <img src={getIcons('AmenitiesLeftImage', operator)} alt="" />
        </div>
        <div style={{ width: '80%' }}>
          <div className="d-flex font10 montserrat-bold" style={styles.singleTab}>
            ESTÁNDAR DE SEGURIDAD
          </div>

          <div
            className="d-flex font10 montserrat"
            style={{ padding: 15, justifyContent: 'space-around' }}
          >
            <div>
              {firstFloor.map((item, key) => {
                return (
                  <div style={{ marginBottom: key != 5 ? 8 : 0 }}>
                    <span style={{ color: operator.theme_color2 }}>-</span> {item}
                  </div>
                );
              })}
            </div>
            <div style={{ width: 1.4, background: operator.theme_color2 }}></div>
            <div>
              {secondFloor.map(item => {
                return (
                  <div style={{ marginBottom: 8 }}>
                    <span style={{ color: operator.theme_color2 }}>-</span> {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeTenAboutUs);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/ThemeTenPages/ThemeTenAboutUs.js